import React, { useState, useEffect } from "react";

const ProjectCard01 = ({ product }) => {
  const { title, description, techStack, images, active } = product;
  const [carouselActive] = useState(active);
  const [currentImage, setCurrentImage] = useState(0);
  const [, setShowDetails] = useState(false);
  const getSkillColor = (stack) => {
    switch (stack) {
      // case "React.js":
      // case "React":
      //   return "#61DAFB"; // React blue
      // case "Next.js":
      //   return "#000000"; // Next.js black
      // case "Typescript":
      // case "TypeScript":
      //   return "#3178C6"; // TypeScript blue
      // case "Django":
      //   return "#092E20"; // Django green
      // case "PostgreSQL":
      //   return "#336791"; // PostgreSQL blue
      // case "Docker":
      //   return "#2496ED"; // Docker blue
      // case "Kafka":
      //   return "#231F20"; // Kafka black
      // case "Kotlin":
      //   return "#0095D5"; // Kotlin blue
      // case "Flask":
      //   return "#000000"; // Flask black
      // case "Nginx":
      //   return "#009639"; // Nginx green
      // case "Memcached":
      //   return "#276DC3"; // Memcached blue
      // case "AWS":
      //   return "#FF9900"; // AWS orange

      // case "CSS":
      //   return "#264DE4"; // CSS blue
      // case "C++":
      //   return "#00599C"; // C++ blue
      // case "HTML":
      //   return "#E44D26"; // HTML orange
      // case "Canvas":
      //   return "#FF5722"; // Canvas orange
      // case "Vanilla JS":
      //   return "#F7DF1E"; // Vanilla JavaScript yellow
      // case "Gin":
      //   return "#00ADD8"; // Gin blue
      // case "Golang":
      // case "Go":
      //   return "#00ADD8"; // Go blue
      // case "Java":
      //   return "#5382A1"; // Java blue
      // case "JavaFX":
      //   return "#F89820"; // JavaFX orange
      // case "Firebase":
      //   return "#FFCA28"; // Firebase yellow
      // case "SDL2":
      //   return "#A2AAAD"; // SDL2 grey
      // case "Htmx":
      //   return "#0099CC"; // Htmx blue
      default:
        return "#000000"; // Default grey for unspecified skills
    }
  };

  // Image carousel effect
  useEffect(() => {
    if (!carouselActive) return;
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % images.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [carouselActive, images]);

  return (
    <div
      className=" relative flex flex-col md:flex-row group shadow-lg  border-blue-500  border-2 overflow-hidden hover:shadow-2xl transition-shadow duration-300 w-[300px] md:w-[600px] "
      onMouseEnter={() => setShowDetails(true)}
      onMouseLeave={() => setShowDetails(false)}
    >
      {/* Left Side: Image */}
      <div className="relative w-[300px] h-[200px] aspect-video">
        {!product.isVideo ? (
          <>
            <img
              height="200"
              width="300"
              alt="prj"
              src={images[currentImage]}
              className="object-cover object-center h-full w-full"
              effect="blur"
            />
          </>
        ) : (
          <video
            className="object-cover object-center h-full w-full"
            autoPlay
            playsInline
            loop
            muted
          >
            <source src={images[0]} type="video/webm" />
          </video>
        )}

        <div className="absolute top-2 left-2  flex items-center gap-2 shadow-md max-w-[300px] flex-wrap">
          {techStack.map((item) => (
            <div
              style={{
                background: getSkillColor(item),
              }}
              className={` text-white text-xs py-1 px-4 rounded-full shadow-md`}
            >
              {item}
            </div>
          ))}
        </div>
      </div>

      {/* Right Side: Details */}
      <div
        className={` flex flex-col justify-center p-4 w-full md:w-full bg-gradient-to-br from-indigo-500/80 to-blue-500/80 group-hover:from-indigo-500 group-hover:to-blue-500 flex-1 text-white
            `}
      >
        <h3 className={`text-lg font-bold mb-2 text-white`}>{title}</h3>
        <p className={`text-sm text-gray-100`}>{description}</p>
      </div>
    </div>
  );
};

export default ProjectCard01;
